export const contactsData = {
    email: 'jordi@hashbrowns.dev',
    phone: '+15046173006',
    address: 'Bywater, New Orleans, United States - 70118 ',
    sheetAPI: ''
}